export function isCpr(cpr: string): boolean {
	cpr = cpr.replace(/[-\s]/gi, '');
	return cpr && cpr.length === 10;
}
